// import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
// import { getStrapiImageURL } from '~/services/strapiServices/image/getStrapiImageService';
// import { getAgeRatingType, getProductAgeRating } from '~/utilities/ageCheck';
// import { getAvailability } from '~/utilities/availability'; // NEU: Vorbestellung
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Thumbs } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/thumbs';
// import 'react-multi-carousel/lib/styles.css';

// const FREE_SHIPPING_TYPES = ['Versand mit DHL Paket', 'Kostenloser Versand'];
// const FREE_SHIPPING_MIN_PRICE = 50;

// const freeShippingBadgeStyle = {
//     borderRadius: '3px',
//     background: 'rgb(233, 247, 239)',
//     border: '1px solid rgb(183, 228, 199)',
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '2px 6px',
//     width: 'fit-content',
//     fontSize: '10px',
//     lineHeight: '14px',
//     fontWeight: 700,
//     color: 'rgb(14, 129, 58)',
//     boxSizing: 'border-box',
//     letterSpacing: '0.3px',
//     whiteSpace: 'nowrap',
//     flexShrink: 0,
//     textTransform: 'uppercase',
// };

// // Altersfreigabe-Badge (USK / FSK / Alkohol / Tabak ab 16 bzw. 18), dezentes Grau
// const ageBadgeStyle = {
//     borderRadius: '3px',
//     background: 'rgb(240, 241, 243)',
//     border: '1px solid rgb(214, 217, 222)',
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '2px 6px',
//     width: 'fit-content',
//     fontSize: '10px',
//     lineHeight: '14px',
//     fontWeight: 700,
//     color: 'rgb(58, 63, 71)',
//     boxSizing: 'border-box',
//     letterSpacing: '0.3px',
//     whiteSpace: 'nowrap',
//     flexShrink: 0,
//     textTransform: 'uppercase',
// };

// // NEU: Vorbesteller-Badge (blau, passt zu SPECIAL_BADGE_TONES.preorder in ProductParts)
// const preorderBadgeStyle = {
//     borderRadius: '3px',
//     background: 'rgb(232, 241, 251)',
//     border: '1px solid rgb(184, 211, 240)',
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '2px 6px',
//     width: 'fit-content',
//     fontSize: '10px',
//     lineHeight: '14px',
//     fontWeight: 700,
//     color: 'rgb(15, 76, 138)',
//     boxSizing: 'border-box',
//     letterSpacing: '0.3px',
//     whiteSpace: 'nowrap',
//     flexShrink: 0,
//     textTransform: 'uppercase',
// };

// const ThumbnailDefault = ({ product }) => {
//     const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

//     const [isMobile, setIsMobile] = useState(false);
//     const [showModal, setShowModal] = useState(false);
//     const [modalIndex, setModalIndex] = useState(0);

//     const primarySwiperRef = useRef(null);
//     const modalSwiperRef = useRef(null);
//     const modalThumbsRef = useRef(null);

//     const [thumbsSwiper, setThumbsSwiper] = useState(null);
//     const [activeIndex, setActiveIndex] = useState(0);
//     const [modalActiveIndex, setModalActiveIndex] = useState(0);

//     const horizontalThumbsRef = useRef(null);

//     const [horizontalThumbsNav, setHorizontalThumbsNav] = useState({ isBeginning: true, isEnd: false });

//     const [primarySwiper, setPrimarySwiper] = useState(null);
//     const [galleryWidth, setGalleryWidth] = useState(null);
//     const [galleryHeight, setGalleryHeight] = useState(null);

//     const updateActiveImageWidth = useCallback(() => {
//         if (!primarySwiper?.el) return;
//     }, [primarySwiper]);

//     const refreshGallerySize = useCallback(() => {
//         if (!primarySwiper?.el) return;

//         primarySwiper.update();
//         primarySwiper.updateSize();
//         primarySwiper.updateSlides();

//         const w = primarySwiper.el.clientWidth;
//         const h = primarySwiper.el.clientHeight;
//         if (w) setGalleryWidth(w);
//         if (h) setGalleryHeight(h);
//     }, [primarySwiper]);

//     useEffect(() => {
//         const updateLayout = () => {
//             setIsMobile(window.innerWidth <= 768);
//             refreshGallerySize();
//         };
//         updateLayout();
//         window.addEventListener('resize', updateLayout);
//         return () => window.removeEventListener('resize', updateLayout);
//     }, [refreshGallerySize]);

//     useEffect(() => {
//         if (!primarySwiper?.el) return;

//         refreshGallerySize();

//         const raf = requestAnimationFrame(refreshGallerySize);
//         const timeout = setTimeout(refreshGallerySize, 150);

//         let ro;
//         if (typeof ResizeObserver !== 'undefined') {
//             ro = new ResizeObserver(refreshGallerySize);
//             ro.observe(primarySwiper.el);
//         } else {
//             window.addEventListener('resize', refreshGallerySize);
//         }

//         return () => {
//             cancelAnimationFrame(raf);
//             clearTimeout(timeout);
//             if (ro) ro.disconnect();
//             window.removeEventListener('resize', refreshGallerySize);
//         };
//     }, [primarySwiper, refreshGallerySize]);

//     const images = useMemo(() => {
//         const allImages = [];

//         if (product?.selectedVariant?.attributes) {
//             if (product.selectedVariant.attributes.base_image) {
//                 allImages.push({
//                     url: getStrapiImageURL({
//                         data: { attributes: { base_image: product.selectedVariant.attributes.base_image } },
//                     }),
//                 });
//             }

//             if (product.selectedVariant.attributes.additional_images) {
//                 product.selectedVariant.attributes.additional_images.split(',').forEach((image) => {
//                     allImages.push({
//                         url: getStrapiImageURL({
//                             data: { attributes: { base_image: image.trim() } },
//                         }),
//                     });
//                 });
//             }
//         }

//         if (allImages.length === 0 || !product?.selectedVariant) {
//             if (product?.attributes?.base_image) {
//                 allImages.push({
//                     url: getStrapiImageURL({
//                         data: { attributes: { base_image: product.attributes.base_image } },
//                     }),
//                 });
//             }

//             if (product?.attributes?.additional_images) {
//                 product.attributes.additional_images.split(',').forEach((image) => {
//                     allImages.push({
//                         url: getStrapiImageURL({
//                             data: { attributes: { base_image: image.trim() } },
//                         }),
//                     });
//                 });
//             }
//         }

//         if (allImages.length === 0) allImages.push({ url: placeholderURL });
//         return allImages;
//     }, [product?.selectedVariant, product?.attributes]);

//     const thumbnailImages = useMemo(() => {
//         const allThumbnailImages = [];

//         if (product?.selectedVariant?.attributes) {
//             if (product.selectedVariant.attributes.base_image_thumbnail) {
//                 allThumbnailImages.push({
//                     url: getStrapiImageURL({
//                         data: { attributes: { base_image: product.selectedVariant.attributes.base_image_thumbnail } },
//                     }),
//                 });
//             }

//             if (product.selectedVariant.attributes.additional_images_thumbnail) {
//                 product.selectedVariant.attributes.additional_images_thumbnail.split(',').forEach((thumbnail) => {
//                     allThumbnailImages.push({
//                         url: getStrapiImageURL({
//                             data: { attributes: { base_image: thumbnail.trim() } },
//                         }),
//                     });
//                 });
//             }
//         }

//         if (allThumbnailImages.length === 0 || !product?.selectedVariant) {
//             if (product?.attributes?.base_image_thumbnail) {
//                 allThumbnailImages.push({
//                     url: getStrapiImageURL({
//                         data: { attributes: { base_image: product.attributes.base_image_thumbnail } },
//                     }),
//                 });
//             }

//             if (product?.attributes?.additional_images_thumbnail) {
//                 product.attributes.additional_images_thumbnail.split(',').forEach((thumbnail) => {
//                     allThumbnailImages.push({
//                         url: getStrapiImageURL({
//                             data: { attributes: { base_image: thumbnail.trim() } },
//                         }),
//                     });
//                 });
//             }
//         }

//         if (allThumbnailImages.length === 0) allThumbnailImages.push({ url: placeholderURL });
//         return allThumbnailImages;
//     }, [product?.selectedVariant, product?.attributes]);

//     const badgeAttrs = useMemo(
//         () => product?.selectedVariant?.attributes || product?.attributes || {},
//         [product?.selectedVariant, product?.attributes]
//     );

//     const currentPrice = useMemo(
//         () => (badgeAttrs.price != null ? Number(badgeAttrs.price) : null),
//         [badgeAttrs]
//     );

//     // Altersfreigabe (null = kein Badge, sonst { type, limit, label, badgeText }).
//     // Alter (minAge): Wert der gewählten Variante, sonst der des Hauptprodukts.
//     // Art (age_rating_type: USK, FSK, Alkohol, Tabak): Hat die Variante keinen gültigen Typ
//     // (leer / "keine"), gilt der Typ des Hauptprodukts.
//     const ageRating = useMemo(() => {
//         const parentAttrs = product?.attributes || {};

//         return getProductAgeRating({
//             minAge: badgeAttrs.minAge ?? parentAttrs.minAge,
//             ageRatingType: getAgeRatingType(badgeAttrs.age_rating_type)
//                 ? badgeAttrs.age_rating_type
//                 : parentAttrs.age_rating_type,
//         });
//     }, [badgeAttrs, product?.attributes]);

//     const shippingType = useMemo(() => {
//         const rawShippingType =
//             badgeAttrs.shippings?.data?.attributes?.shipping_type || 'Kostenloser Versand';
//         const s = String(rawShippingType).trim().toLowerCase();
//         if (s === 'versand mit dhl paket') return 'Versand mit DHL Paket';
//         if (s === 'lieferung durch spedition') return 'Lieferung durch Spedition';
//         if (['digitaler versand', 'esd versand', 'esd'].includes(s)) return 'ESD Versand';
//         return rawShippingType;
//     }, [badgeAttrs]);

//     const showFreeShippingBadge = useMemo(
//         () =>
//             FREE_SHIPPING_TYPES.includes(shippingType) &&
//             currentPrice !== null &&
//             currentPrice >= FREE_SHIPPING_MIN_PRICE,
//         [shippingType, currentPrice]
//     );

//     // NEU: Vorbestellung - gleiche Logik wie im Warenkorb-Button (ModuleDetailShoppingActions)
//     const availability = useMemo(() => {
//         const shippingAttrs =
//             badgeAttrs.shippings?.data?.attributes ||
//             product?.attributes?.shippings?.data?.attributes ||
//             null;
//         return getAvailability(badgeAttrs, shippingAttrs);
//     }, [badgeAttrs, product?.attributes]);

//     const showPreorderBadge = availability.status === 'preorder';

//     const updateThumbsSlidesPerView = useCallback((swiper) => {
//         if (!swiper || !swiper.el) return;

//         const containerWidth = swiper.el.clientWidth;
//         const slideWidth = 74;
//         const gap = 10;
//         const visibleSlides = Math.floor(containerWidth / (slideWidth + gap));
//         swiper.params.slidesPerView = Math.max(3, visibleSlides);
//         swiper.update();
//     }, []);

//     useEffect(() => {
//         if (!thumbsSwiper || !thumbsSwiper.el) return;

//         updateThumbsSlidesPerView(thumbsSwiper);

//         const handleResize = () => updateThumbsSlidesPerView(thumbsSwiper);
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, [thumbsSwiper, updateThumbsSlidesPerView]);

//     const closeModal = () => {
//         setShowModal(false);
//         document.body.style.overflow = 'unset';
//     };

//     const openModal = (index = 0) => {
//         setModalIndex(index);
//         setModalActiveIndex(index);
//         setShowModal(true);
//         document.body.style.overflow = 'hidden';
//     };

//     useEffect(() => {
//         if (!showModal) return;

//         const handleKeyDown = (e) => {
//             if (e.key === 'Escape') {
//                 closeModal();
//             } else if (e.key === 'ArrowLeft') {
//                 e.preventDefault();
//                 modalSwiperRef.current?.swiper?.slidePrev();
//             } else if (e.key === 'ArrowRight') {
//                 e.preventDefault();
//                 modalSwiperRef.current?.swiper?.slideNext();
//             }
//         };

//         window.addEventListener('keydown', handleKeyDown);
//         return () => window.removeEventListener('keydown', handleKeyDown);
//     }, [showModal]);

//     const onPrimarySlideChange = (swiper) => {
//         setActiveIndex(swiper.realIndex);
//     };

//     const handleThumbnailClick = (index) => {
//         setActiveIndex(index);
//         primarySwiperRef.current?.swiper?.slideTo(index);
//     };

//     const handlePrevClick = (e) => {
//         e.stopPropagation();
//         modalSwiperRef.current?.swiper?.slidePrev();
//     };

//     const handleNextClick = (e) => {
//         e.stopPropagation();
//         modalSwiperRef.current?.swiper?.slideNext();
//     };

//     const handleThumbClick = (swiper, index) => {
//         modalSwiperRef.current?.swiper?.slideTo(index);
//     };

//     return (
//         <>
//             <style jsx global>{`
//                 .product-modal-overlay .modal-thumb-slide {
//                     width: 74px !important;
//                     flex-shrink: 0 !important;
//                     height: 78px !important;
//                     margin-right: 10px !important;
//                 }
//                 .product-modal-overlay .modal-thumb-slide:last-child {
//                     margin-right: 0 !important;
//                 }

//                 .ps-wrapper.carousel--productImages {
//                     overflow: hidden;
//                     position: relative;
//                     width: 100%;
//                     max-width: 100%;
//                     aspect-ratio: 1 / 1; /* NEU: fester Platz, z. B. 1/1 oder 4/5 */
//                 }
//                 .ps-wrapper.carousel--productImages .swiper {
//                     width: 100%;
//                     max-width: 100%;
//                     height: 100%; /* NEU */
//                     overflow: hidden;
//                     clip-path: inset(0); /* schneidet exakt am Rand ab (Subpixel-Fix bei Zoom) */
//                 }
//                 .ps-wrapper.carousel--productImages .swiper-wrapper {
//                     max-width: 100%;
//                     height: 100%; /* NEU */
//                 }
//                 .ps-wrapper.carousel--productImages .swiper-slide {
//                     display: flex !important;
//                     align-items: center !important;
//                     justify-content: center !important;
//                     height: 100% !important; /* NEU */
//                     max-width: 100% !important;
//                     box-sizing: border-box;
//                 }
//                 .ps-wrapper.carousel--productImages img {
//                     max-width: 100%;
//                     max-height: 100%; /* NEU */
//                     height: auto;
//                 }

//                 .ps-swiper-arrow-layer {
//                     position: absolute !important;
//                     inset: 0 !important;
//                     z-index: 50 !important;
//                     pointer-events: none !important;
//                 }

//                 .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     pointer-events: auto !important;
//                     top: 50% !important;
//                     transform: translateY(-50%) !important;
//                     bottom: auto !important;
//                     margin: 0 !important;
//                     background: rgba(0, 0, 0, 0.8) !important;
//                     border-radius: 50% !important;
//                     width: 44px !important;
//                     height: 44px !important;
//                     min-width: 44px !important;
//                     min-height: 44px !important;
//                     display: flex !important;
//                     align-items: center !important;
//                     justify-content: center !important;
//                     transition: background-color 0.2s ease, opacity 0.2s ease !important;
//                 }
//                 .ps-swiper-arrow-layer .react-multiple-carousel__arrow:hover {
//                     background: rgba(0, 0, 0, 0.5) !important;
//                 }
//                 .ps-swiper-arrow-layer .react-multiple-carousel__arrow--left {
//                     left: 15px !important;
//                     right: auto !important;
//                 }
//                 .ps-swiper-arrow-layer .react-multiple-carousel__arrow--right {
//                     right: 15px !important;
//                     left: auto !important;
//                 }

//                 .ps-swiper-arrow-layer .react-multiple-carousel__arrow:disabled {
//                     display: none !important;
//                 }

//                 .ps-carousel-hover-wrapper .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     opacity: 0 !important;
//                     visibility: hidden !important;
//                     pointer-events: none !important;
//                 }
//                 .ps-carousel-hover-wrapper:hover .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     opacity: 1 !important;
//                     visibility: visible !important;
//                     pointer-events: auto !important;
//                 }
//                 .react-multiple-carousel__arrow:hover {
//                     opacity: 1 !important;
//                     visibility: visible !important;
//                 }
//                 .ps-carousel-hover-wrapper.is-mobile .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     opacity: 1 !important;
//                     visibility: visible !important;
//                     pointer-events: auto !important;
//                 }

//                 .ps-gallery-layout {
//                     display: block;
//                     width: 100%;
//                 }

//                 .ps-gallery-main-image {
//                     width: 100%;
//                     box-sizing: border-box;
//                 }

//                 @media (max-width: 768px) {
//                     .ps-gallery-layout {
//                         display: grid;
//                         grid-template-columns: 76px 1fr;
//                         grid-template-areas:
//                             'thumbs image'
//                             'caption caption';
//                         column-gap: 8px;
//                         row-gap: 0;
//                         align-items: start;
//                     }
//                     .ps-gallery-main-image {
//                         grid-area: image;
//                         min-width: 0;
//                         width: 100%;
//                         max-width: 100%;
//                     }
//                     .thumbnail-caption-container {
//                         grid-area: caption;
//                         margin-top: 6px !important;
//                     }
//                     .product__thumbnailImages-wrapper {
//                         grid-area: thumbs;
//                         flex-direction: column !important;
//                         align-items: center;
//                         width: 76px !important;
//                         margin-top: 0 !important;
//                     }

//                     .ps-gallery-layout.single-image {
//                         grid-template-columns: 1fr;
//                         grid-template-areas:
//                             'image'
//                             'caption';
//                     }
//                 }

//                 .thumbnail-caption-container {
//                     width: 100%;
//                     text-align: center;
//                     box-sizing: border-box;
//                 }

//                 .product__thumbnailImages-wrapper {
//                     display: flex;
//                     flex-direction: row;
//                     align-items: center;
//                     gap: 4px;
//                     margin-top: 12px;
//                     height: 100px;
//                     width: 100%;
//                     box-sizing: border-box;
//                 }

//                 .ps-thumb-list {
//                     height: 101%;
//                     flex-direction: row;
//                     align-items: center;
//                     scroll-margin-top: 7.7rem;
//                     display: flex;
//                     outline: none !important;
//                     box-sizing: inherit;
//                     margin: 0px;
//                     padding: 0px;
//                     flex: 1 1 auto;
//                     min-width: 0;
//                     overflow: hidden;
//                 }

//                 .ps-thumb-list .swiper {
//                     width: 100%;
//                     height: 100%;
//                 }

//                 .ps-thumb-list .swiper-wrapper {
//                     align-items: center;
//                 }

//                 .ps-thumb-list .swiper-slide {
//                     width: 100px !important;
//                     height: 100px !important;
//                     flex-shrink: 0;
//                     display: flex !important;
//                     align-items: center !important;
//                     justify-content: center !important;
//                 }
//                 .ps-thumb-list img {
//                     width: 100px !important;
//                     height: 100px !important;
//                     object-fit: contain !important;
//                     border: 1px solid transparent;
//                     border-radius: 10px;
//                     cursor: pointer;
//                     transition: border-color 0.2s ease;
//                 }
//                 .ps-thumb-list img.active {
//                     border-color: var(--color-primary, #1a1a1a);
//                 }

//                 .ps-thumb-arrow {
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     width: 2.4rem;
//                     height: 4.4rem;
//                     border: none;
//                     background: transparent;
//                     cursor: pointer;
//                     color: #1a1a1a;
//                     flex-shrink: 0;
//                     transition: background-color 0.2s ease, opacity 0.2s ease;
//                 }
//                 .ps-thumb-arrow:hover:not(:disabled) {
//                     background: #ecedf0;
//                 }
//                 .ps-thumb-arrow:disabled {
//                     opacity: 0.3;
//                     cursor: default;
//                 }
//                 .ps-thumb-arrow svg {
//                     width: 1.6rem;
//                     height: 1.6rem;
//                     fill: currentColor;
//                 }

//                 .ps-thumb-arrow--right svg {
//                     transform: rotate(0deg);
//                 }
//                 .ps-thumb-arrow--left svg {
//                     transform: rotate(180deg);
//                 }

//                 @media (max-width: 768px) {
//                     .ps-thumb-list {
//                         flex-direction: column;
//                         height: 100%;
//                         width: 100%;
//                     }
//                     .ps-thumb-list .swiper-slide {
//                         width: 64px !important;
//                         height: 64px !important;
//                     }
//                     .ps-thumb-list img {
//                         width: 64px !important;
//                         height: 64px !important;
//                     }
//                     .ps-thumb-arrow {
//                         width: 100% !important;
//                         height: 2rem !important;
//                     }
//                     .ps-thumb-arrow--left svg {
//                         transform: rotate(-90deg);
//                     }
//                     .ps-thumb-arrow--right svg {
//                         transform: rotate(90deg);
//                     }
//                 }

//                 .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     opacity: 1 !important;
//                     visibility: visible !important;
//                     pointer-events: auto !important;
//                     z-index: 2147483647 !important;
//                 }

//                 .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
//                     background: #f4f4f4 !important;
//                     color: #1a1a1a !important;
//                 }
//                 .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow::before {
//                     color: #1a1a1a !important;
//                 }
//                 .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow svg {
//                     fill: #1a1a1a !important;
//                 }

//                 .ps-product__thumbnail {
//                     width: 100%;
//                     box-sizing: border-box;
//                 }

//                 .ps-product__thumbnail > figure {
//                     width: 100%;
//                     flex: 1 1 auto;
//                     min-width: 0;
//                 }

//                 .ps-product__thumbnail-badges {
//                     position: absolute;
//                     top: 12px;
//                     left: 12px;
//                     z-index: 60;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: flex-start;
//                     gap: 6px;
//                     pointer-events: none;
//                 }

//                 @media (max-width: 768px) {
//                     .ps-product__thumbnail-badges {
//                         left: auto;
//                         right: 12px;
//                         align-items: flex-end;
//                     }
//                 }
//             `}</style>

//             <div className="ps-product__thumbnail" data-vertical={!isMobile} style={{ position: 'relative' }}>
//                 {(showPreorderBadge || showFreeShippingBadge || ageRating) && (
//                     <div className="ps-product__thumbnail-badges">
//                         {showPreorderBadge && (
//                             <div
//                                 data-testid="product-preorder-badge"
//                                 className="ps-product__preorder-badge"
//                                 aria-label="Dieser Artikel kann vorbestellt werden"
//                                 style={preorderBadgeStyle}
//                             >
//                                 Vorbestellung
//                             </div>
//                         )}
//                         {showFreeShippingBadge && (
//                             <div
//                                 data-testid="product-free-shipping-badge"
//                                 className="ps-product__free-shipping-badge"
//                                 style={freeShippingBadgeStyle}
//                             >
//                                 Gratis Versand
//                             </div>
//                         )}
//                         {ageRating && (
//                             <div
//                                 data-testid="product-age-badge"
//                                 data-age-type={ageRating.type}
//                                 className="ps-product__age-badge"
//                                 aria-label={`${ageRating.badgeText} Jahren`}
//                                 style={ageBadgeStyle}
//                             >
//                                 {ageRating.badgeText}
//                             </div>
//                         )}
//                     </div>
//                 )}

//                 <figure style={{ margin: 0, width: '100%', flex: '1 1 auto', minWidth: 0 }}>
//                     <div className={`ps-gallery-layout ${images.length <= 1 ? 'single-image' : ''}`}>
//                         <div className="ps-gallery-main-image">
//                             <div
//                                 className={`ps-wrapper carousel--productImages ps-carousel-hover-wrapper ${
//                                     isMobile ? 'is-mobile' : ''
//                                 }`}
//                             >
//                                 {images.length > 1 && (
//                                     <div className="ps-swiper-arrow-layer">
//                                         <button
//                                             aria-label="Go to previous slide"
//                                             className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
//                                             type="button"
//                                             onClick={() => primarySwiperRef.current?.swiper?.slidePrev()}
//                                             disabled={activeIndex === 0}
//                                         />
//                                         <button
//                                             aria-label="Go to next slide"
//                                             className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
//                                             type="button"
//                                             onClick={() => primarySwiperRef.current?.swiper?.slideNext()}
//                                             disabled={activeIndex === images.length - 1}
//                                         />
//                                     </div>
//                                 )}

//                                 <Swiper
//                                     ref={primarySwiperRef}
//                                     modules={[Navigation]}
//                                     spaceBetween={10}
//                                     roundLengths={true}
//                                     onSwiper={(swiper) => {
//                                         setPrimarySwiper(swiper);
//                                         setActiveIndex(swiper.realIndex);
//                                     }}
//                                     onSlideChange={onPrimarySlideChange}
//                                     observer={true}
//                                     observeParents={true}
//                                     style={{ height: '100%' }}
//                                 >
//                                     {images.map((item, index) => (
//                                         <SwiperSlide
//                                             key={index}
//                                             className="item"
//                                             style={{
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                             }}
//                                         >
//                                             <div
//                                                 onClick={() => openModal(index)}
//                                                 style={{
//                                                     width: '100%',
//                                                     height: '100%',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                 }}
//                                             >
//                                                 <img
//                                                     src={item.url}
//                                                     alt={`Produktbild ${index + 1}`}
//                                                     onError={(e) => {
//                                                         e.target.onerror = null;
//                                                         e.target.src = placeholderURL;
//                                                     }}
//                                                     onLoad={refreshGallerySize}
//                                                     style={{
//                                                         maxWidth: '100%',
//                                                         maxHeight: '100%',
//                                                         width: 'auto',
//                                                         height: 'auto',
//                                                         display: 'block',
//                                                         objectFit: 'contain',
//                                                         margin: 'auto',
//                                                     }}
//                                                 />
//                                             </div>
//                                         </SwiperSlide>
//                                     ))}
//                                 </Swiper>
//                             </div>
//                         </div>

//                         <div className="thumbnail-caption-container">
//                             <p
//                                 className="thumbnail-caption"
//                                 style={{
//                                     fontSize: '14px',
//                                     color: 'var(--color-text)',
//                                     display: 'inline-block',
//                                     marginTop: '10px',
//                                     opacity: 0.55,
//                                 }}
//                             >
//                                 Abb. kann vom Original abweichen.
//                             </p>
//                         </div>

//                         {images.length > 1 && (
//                             <div
//                                 className="product__thumbnailImages-wrapper"
//                                 style={{
//                                     height: isMobile && galleryHeight ? `${galleryHeight}px` : undefined,
//                                 }}
//                             >
//                                 <button
//                                     type="button"
//                                     className="ps-thumb-arrow ps-thumb-arrow--left"
//                                     aria-label="Zurück zum vorherigen Produktbild"
//                                     onClick={() => horizontalThumbsRef.current?.swiper?.slidePrev()}
//                                     disabled={horizontalThumbsNav.isBeginning}
//                                 >
//                                     <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
//                                         <path d="m6.71 21.71-1.42-1.42 9.3-9.29-9.3-9.29L6.71.29 17.41 11 6.71 21.71Z" />
//                                     </svg>
//                                 </button>

//                                 <div className="ps-thumb-list">
//                                     <Swiper
//                                         key={isMobile ? 'vertical' : 'horizontal'}
//                                         ref={horizontalThumbsRef}
//                                         className="swiper-carousel--variants"
//                                         spaceBetween={5}
//                                         slidesPerView="auto"
//                                         direction={isMobile ? 'vertical' : 'horizontal'}
//                                         freeMode={true}
//                                         observer={true}
//                                         observeParents={true}
//                                         onSwiper={(swiper) =>
//                                             setHorizontalThumbsNav({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd })
//                                         }
//                                         onSlideChange={(swiper) =>
//                                             setHorizontalThumbsNav({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd })
//                                         }
//                                     >
//                                         {thumbnailImages.map((item, index) => (
//                                             <SwiperSlide className="item" key={index}>
//                                                 <img
//                                                     src={item.url}
//                                                     className={`swiper-slide-image ${index === activeIndex ? 'active' : ''}`}
//                                                     onError={(e) => {
//                                                         e.target.onerror = null;
//                                                         e.target.src = placeholderURL;
//                                                     }}
//                                                     onClick={() => handleThumbnailClick(index)}
//                                                     onMouseEnter={() => handleThumbnailClick(index)}
//                                                 />
//                                             </SwiperSlide>
//                                         ))}
//                                     </Swiper>
//                                 </div>

//                                 <button
//                                     type="button"
//                                     className="ps-thumb-arrow ps-thumb-arrow--right"
//                                     aria-label="Weiter zum nächsten Produktbild"
//                                     onClick={() => horizontalThumbsRef.current?.swiper?.slideNext()}
//                                     disabled={horizontalThumbsNav.isEnd}
//                                 >
//                                     <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
//                                         <path d="m6.71 21.71-1.42-1.42 9.3-9.29-9.3-9.29L6.71.29 17.41 11 6.71 21.71Z" />
//                                     </svg>
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </figure>
//             </div>

//             {showModal && (
//                 <div
//                     className="product-modal-overlay"
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         bottom: 0,
//                         background: 'rgba(0,0,0,0.9)',
//                         zIndex: 2147483647,
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: '20px',
//                         gap: '20px',
//                     }}
//                     onClick={closeModal}
//                 >
//                     <button
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             closeModal();
//                         }}
//                         style={{
//                             position: 'absolute',
//                             top: '20px',
//                             right: '20px',
//                             background: 'rgba(255,255,255,0.3)',
//                             border: 'none',
//                             color: 'white',
//                             fontSize: '24px',
//                             lineHeight: '1',
//                             padding: 0,
//                             width: '44px',
//                             height: '44px',
//                             borderRadius: '50%',
//                             cursor: 'pointer',
//                             zIndex: 2147483647,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             fontFamily: 'Arial, sans-serif',
//                         }}
//                     >
//                         <span style={{ display: 'inline-block', transform: 'translateY(-1px)' }}>×</span>
//                     </button>

//                     <div style={{ width: '90vw', maxWidth: '1200px', height: '65vh', position: 'relative' }}>
//                         <Swiper
//                             ref={modalSwiperRef}
//                             spaceBetween={10}
//                             thumbs={thumbsSwiper && thumbsSwiper.el ? { swiper: thumbsSwiper } : undefined}
//                             initialSlide={modalIndex}
//                             modules={[Navigation, Thumbs]}
//                             onSwiper={(swiper) => setModalActiveIndex(swiper.realIndex)}
//                             onSlideChange={(swiper) => setModalActiveIndex(swiper.realIndex)}
//                             style={{ height: '100%' }}
//                         >
//                             {images.map((item, index) => (
//                                 <SwiperSlide key={index}>
//                                     <div
//                                         style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             height: '100%',
//                                         }}
//                                     >
//                                         <img
//                                             src={item.url}
//                                             alt={`Produktbild ${index + 1}`}
//                                             style={{
//                                                 maxWidth: '100%',
//                                                 maxHeight: '100%',
//                                                 objectFit: 'contain',
//                                             }}
//                                         />
//                                     </div>
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>

//                         {images.length > 1 && (
//                             <div className="ps-swiper-arrow-layer">
//                                 <button
//                                     aria-label="Go to previous slide"
//                                     className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
//                                     type="button"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         modalSwiperRef.current?.swiper?.slidePrev();
//                                     }}
//                                     disabled={modalActiveIndex === 0}
//                                 />
//                                 <button
//                                     aria-label="Go to next slide"
//                                     className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
//                                     type="button"
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         modalSwiperRef.current?.swiper?.slideNext();
//                                     }}
//                                     disabled={modalActiveIndex === images.length - 1}
//                                 />
//                             </div>
//                         )}
//                     </div>

//                     {images.length > 1 && (
//                         <div
//                             style={{
//                                 width: '90vw',
//                                 maxWidth: '800px',
//                                 height: '90px',
//                                 background: 'rgba(255,255,255,0.1)',
//                                 borderRadius: '8px',
//                                 padding: '4px',
//                                 backdropFilter: 'blur(10px)',
//                             }}
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <Swiper
//                                 ref={modalThumbsRef}
//                                 spaceBetween={0}
//                                 slidesPerView={6}
//                                 centeredSlides={false}
//                                 watchSlidesProgress={true}
//                                 modules={[Thumbs]}
//                                 onSwiper={(swiper) => setThumbsSwiper(swiper)}
//                                 breakpoints={{
//                                     320: { slidesPerView: 3 },
//                                     768: { slidesPerView: 4 },
//                                     1024: { slidesPerView: 6 },
//                                 }}
//                             >
//                                 {thumbnailImages.map((item, index) => (
//                                     <SwiperSlide key={index} className="modal-thumb-slide">
//                                         <div
//                                             style={{
//                                                 width: '70px',
//                                                 height: '70px',
//                                                 margin: '4px 10px 0 0',
//                                                 cursor: 'pointer',
//                                                 borderRadius: '6px',
//                                                 overflow: 'hidden',
//                                                 opacity: 0.8,
//                                                 transition: 'all 0.3s ease',
//                                             }}
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 handleThumbClick(null, index);
//                                             }}
//                                         >
//                                             <img
//                                                 src={item.url}
//                                                 alt={`Thumbnail ${index}`}
//                                                 style={{
//                                                     width: '100%',
//                                                     height: '100%',
//                                                     objectFit: 'cover',
//                                                 }}
//                                             />
//                                         </div>
//                                     </SwiperSlide>
//                                 ))}
//                             </Swiper>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </>
//     );
// };

// export default ThumbnailDefault;


import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { getStrapiImageURL } from '~/services/strapiServices/image/getStrapiImageService';
import { getAgeRatingType, getProductAgeRating } from '~/utilities/ageCheck';
import { getAvailability } from '~/utilities/availability'; // NEU: Vorbestellung
import {
    PreorderIcon,
    FreeShippingIcon,
    AgeRatingIcon,
} from '~/components/elements/products/modules/ProductParts';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import 'react-multi-carousel/lib/styles.css';

const FREE_SHIPPING_TYPES = ['Versand mit DHL Paket', 'Kostenloser Versand'];
const FREE_SHIPPING_MIN_PRICE = 50;

const freeShippingBadgeStyle = {
    borderRadius: '3px',
    background: 'rgb(233, 247, 239)',
    border: '1px solid rgb(183, 228, 199)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 6px',
    width: 'fit-content',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 700,
    color: 'rgb(14, 129, 58)',
    boxSizing: 'border-box',
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    textTransform: 'uppercase',
};

// Altersfreigabe-Badge (USK / FSK / Alkohol / Tabak ab 16 bzw. 18), dezentes Grau
const ageBadgeStyle = {
    borderRadius: '3px',
    background: 'rgb(240, 241, 243)',
    border: '1px solid rgb(214, 217, 222)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 6px',
    width: 'fit-content',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 700,
    color: 'rgb(58, 63, 71)',
    boxSizing: 'border-box',
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    textTransform: 'uppercase',
};

// NEU: Vorbesteller-Badge (blau, passt zu SPECIAL_BADGE_TONES.preorder in ProductParts)
const preorderBadgeStyle = {
    borderRadius: '3px',
    background: 'rgb(232, 241, 251)',
    border: '1px solid rgb(184, 211, 240)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 6px',
    width: 'fit-content',
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 700,
    color: 'rgb(15, 76, 138)',
    boxSizing: 'border-box',
    letterSpacing: '0.3px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    textTransform: 'uppercase',
};

const ThumbnailDefault = ({ product }) => {
    const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

    const [isMobile, setIsMobile] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);

    const primarySwiperRef = useRef(null);
    const modalSwiperRef = useRef(null);
    const modalThumbsRef = useRef(null);

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [modalActiveIndex, setModalActiveIndex] = useState(0);

    const horizontalThumbsRef = useRef(null);

    const [horizontalThumbsNav, setHorizontalThumbsNav] = useState({ isBeginning: true, isEnd: false });

    const [primarySwiper, setPrimarySwiper] = useState(null);
    const [galleryWidth, setGalleryWidth] = useState(null);
    const [galleryHeight, setGalleryHeight] = useState(null);

    const updateActiveImageWidth = useCallback(() => {
        if (!primarySwiper?.el) return;
    }, [primarySwiper]);

    const refreshGallerySize = useCallback(() => {
        if (!primarySwiper?.el) return;

        primarySwiper.update();
        primarySwiper.updateSize();
        primarySwiper.updateSlides();

        const w = primarySwiper.el.clientWidth;
        const h = primarySwiper.el.clientHeight;
        if (w) setGalleryWidth(w);
        if (h) setGalleryHeight(h);
    }, [primarySwiper]);

    useEffect(() => {
        const updateLayout = () => {
            setIsMobile(window.innerWidth <= 768);
            refreshGallerySize();
        };
        updateLayout();
        window.addEventListener('resize', updateLayout);
        return () => window.removeEventListener('resize', updateLayout);
    }, [refreshGallerySize]);

    useEffect(() => {
        if (!primarySwiper?.el) return;

        refreshGallerySize();

        const raf = requestAnimationFrame(refreshGallerySize);
        const timeout = setTimeout(refreshGallerySize, 150);

        let ro;
        if (typeof ResizeObserver !== 'undefined') {
            ro = new ResizeObserver(refreshGallerySize);
            ro.observe(primarySwiper.el);
        } else {
            window.addEventListener('resize', refreshGallerySize);
        }

        return () => {
            cancelAnimationFrame(raf);
            clearTimeout(timeout);
            if (ro) ro.disconnect();
            window.removeEventListener('resize', refreshGallerySize);
        };
    }, [primarySwiper, refreshGallerySize]);

    const images = useMemo(() => {
        const allImages = [];

        if (product?.selectedVariant?.attributes) {
            if (product.selectedVariant.attributes.base_image) {
                allImages.push({
                    url: getStrapiImageURL({
                        data: { attributes: { base_image: product.selectedVariant.attributes.base_image } },
                    }),
                });
            }

            if (product.selectedVariant.attributes.additional_images) {
                product.selectedVariant.attributes.additional_images.split(',').forEach((image) => {
                    allImages.push({
                        url: getStrapiImageURL({
                            data: { attributes: { base_image: image.trim() } },
                        }),
                    });
                });
            }
        }

        if (allImages.length === 0 || !product?.selectedVariant) {
            if (product?.attributes?.base_image) {
                allImages.push({
                    url: getStrapiImageURL({
                        data: { attributes: { base_image: product.attributes.base_image } },
                    }),
                });
            }

            if (product?.attributes?.additional_images) {
                product.attributes.additional_images.split(',').forEach((image) => {
                    allImages.push({
                        url: getStrapiImageURL({
                            data: { attributes: { base_image: image.trim() } },
                        }),
                    });
                });
            }
        }

        if (allImages.length === 0) allImages.push({ url: placeholderURL });
        return allImages;
    }, [product?.selectedVariant, product?.attributes]);

    const thumbnailImages = useMemo(() => {
        const allThumbnailImages = [];

        if (product?.selectedVariant?.attributes) {
            if (product.selectedVariant.attributes.base_image_thumbnail) {
                allThumbnailImages.push({
                    url: getStrapiImageURL({
                        data: { attributes: { base_image: product.selectedVariant.attributes.base_image_thumbnail } },
                    }),
                });
            }

            if (product.selectedVariant.attributes.additional_images_thumbnail) {
                product.selectedVariant.attributes.additional_images_thumbnail.split(',').forEach((thumbnail) => {
                    allThumbnailImages.push({
                        url: getStrapiImageURL({
                            data: { attributes: { base_image: thumbnail.trim() } },
                        }),
                    });
                });
            }
        }

        if (allThumbnailImages.length === 0 || !product?.selectedVariant) {
            if (product?.attributes?.base_image_thumbnail) {
                allThumbnailImages.push({
                    url: getStrapiImageURL({
                        data: { attributes: { base_image: product.attributes.base_image_thumbnail } },
                    }),
                });
            }

            if (product?.attributes?.additional_images_thumbnail) {
                product.attributes.additional_images_thumbnail.split(',').forEach((thumbnail) => {
                    allThumbnailImages.push({
                        url: getStrapiImageURL({
                            data: { attributes: { base_image: thumbnail.trim() } },
                        }),
                    });
                });
            }
        }

        if (allThumbnailImages.length === 0) allThumbnailImages.push({ url: placeholderURL });
        return allThumbnailImages;
    }, [product?.selectedVariant, product?.attributes]);

    const badgeAttrs = useMemo(
        () => product?.selectedVariant?.attributes || product?.attributes || {},
        [product?.selectedVariant, product?.attributes]
    );

    const currentPrice = useMemo(
        () => (badgeAttrs.price != null ? Number(badgeAttrs.price) : null),
        [badgeAttrs]
    );

    // Altersfreigabe (null = kein Badge, sonst { type, limit, label, badgeText }).
    // Alter (minAge): Wert der gewählten Variante, sonst der des Hauptprodukts.
    // Art (age_rating_type: USK, FSK, Alkohol, Tabak): Hat die Variante keinen gültigen Typ
    // (leer / "keine"), gilt der Typ des Hauptprodukts.
    const ageRating = useMemo(() => {
        const parentAttrs = product?.attributes || {};

        return getProductAgeRating({
            minAge: badgeAttrs.minAge ?? parentAttrs.minAge,
            ageRatingType: getAgeRatingType(badgeAttrs.age_rating_type)
                ? badgeAttrs.age_rating_type
                : parentAttrs.age_rating_type,
        });
    }, [badgeAttrs, product?.attributes]);

    const shippingType = useMemo(() => {
        const rawShippingType =
            badgeAttrs.shippings?.data?.attributes?.shipping_type || 'Kostenloser Versand';
        const s = String(rawShippingType).trim().toLowerCase();
        if (s === 'versand mit dhl paket') return 'Versand mit DHL Paket';
        if (s === 'lieferung durch spedition') return 'Lieferung durch Spedition';
        if (['digitaler versand', 'esd versand', 'esd'].includes(s)) return 'ESD Versand';
        return rawShippingType;
    }, [badgeAttrs]);

    const showFreeShippingBadge = useMemo(
        () =>
            FREE_SHIPPING_TYPES.includes(shippingType) &&
            currentPrice !== null &&
            currentPrice >= FREE_SHIPPING_MIN_PRICE,
        [shippingType, currentPrice]
    );

    // NEU: Vorbestellung - gleiche Logik wie im Warenkorb-Button (ModuleDetailShoppingActions)
    const availability = useMemo(() => {
        const shippingAttrs =
            badgeAttrs.shippings?.data?.attributes ||
            product?.attributes?.shippings?.data?.attributes ||
            null;
        return getAvailability(badgeAttrs, shippingAttrs);
    }, [badgeAttrs, product?.attributes]);

    const showPreorderBadge = availability.status === 'preorder';

    const updateThumbsSlidesPerView = useCallback((swiper) => {
        if (!swiper || !swiper.el) return;

        const containerWidth = swiper.el.clientWidth;
        const slideWidth = 74;
        const gap = 10;
        const visibleSlides = Math.floor(containerWidth / (slideWidth + gap));
        swiper.params.slidesPerView = Math.max(3, visibleSlides);
        swiper.update();
    }, []);

    useEffect(() => {
        if (!thumbsSwiper || !thumbsSwiper.el) return;

        updateThumbsSlidesPerView(thumbsSwiper);

        const handleResize = () => updateThumbsSlidesPerView(thumbsSwiper);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [thumbsSwiper, updateThumbsSlidesPerView]);

    const closeModal = () => {
        setShowModal(false);
        document.body.style.overflow = 'unset';
    };

    const openModal = (index = 0) => {
        setModalIndex(index);
        setModalActiveIndex(index);
        setShowModal(true);
        document.body.style.overflow = 'hidden';
    };

    useEffect(() => {
        if (!showModal) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            } else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                modalSwiperRef.current?.swiper?.slidePrev();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                modalSwiperRef.current?.swiper?.slideNext();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [showModal]);

    const onPrimarySlideChange = (swiper) => {
        setActiveIndex(swiper.realIndex);
    };

    const handleThumbnailClick = (index) => {
        setActiveIndex(index);
        primarySwiperRef.current?.swiper?.slideTo(index);
    };

    const handlePrevClick = (e) => {
        e.stopPropagation();
        modalSwiperRef.current?.swiper?.slidePrev();
    };

    const handleNextClick = (e) => {
        e.stopPropagation();
        modalSwiperRef.current?.swiper?.slideNext();
    };

    const handleThumbClick = (swiper, index) => {
        modalSwiperRef.current?.swiper?.slideTo(index);
    };

    return (
        <>
            <style jsx global>{`
                .product-modal-overlay .modal-thumb-slide {
                    width: 74px !important;
                    flex-shrink: 0 !important;
                    height: 78px !important;
                    margin-right: 10px !important;
                }
                .product-modal-overlay .modal-thumb-slide:last-child {
                    margin-right: 0 !important;
                }

                .ps-wrapper.carousel--productImages {
                    overflow: hidden;
                    position: relative;
                    width: 100%;
                    max-width: 100%;
                    aspect-ratio: 1 / 1; /* NEU: fester Platz, z. B. 1/1 oder 4/5 */
                }
                .ps-wrapper.carousel--productImages .swiper {
                    width: 100%;
                    max-width: 100%;
                    height: 100%; /* NEU */
                    overflow: hidden;
                    clip-path: inset(0); /* schneidet exakt am Rand ab (Subpixel-Fix bei Zoom) */
                }
                .ps-wrapper.carousel--productImages .swiper-wrapper {
                    max-width: 100%;
                    height: 100%; /* NEU */
                }
                .ps-wrapper.carousel--productImages .swiper-slide {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    height: 100% !important; /* NEU */
                    max-width: 100% !important;
                    box-sizing: border-box;
                }
                .ps-wrapper.carousel--productImages img {
                    max-width: 100%;
                    max-height: 100%; /* NEU */
                    height: auto;
                }

                .ps-swiper-arrow-layer {
                    position: absolute !important;
                    inset: 0 !important;
                    z-index: 50 !important;
                    pointer-events: none !important;
                }

                .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    pointer-events: auto !important;
                    top: 50% !important;
                    transform: translateY(-50%) !important;
                    bottom: auto !important;
                    margin: 0 !important;
                    background: rgba(0, 0, 0, 0.8) !important;
                    border-radius: 50% !important;
                    width: 44px !important;
                    height: 44px !important;
                    min-width: 44px !important;
                    min-height: 44px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    transition: background-color 0.2s ease, opacity 0.2s ease !important;
                }
                .ps-swiper-arrow-layer .react-multiple-carousel__arrow:hover {
                    background: rgba(0, 0, 0, 0.5) !important;
                }
                .ps-swiper-arrow-layer .react-multiple-carousel__arrow--left {
                    left: 15px !important;
                    right: auto !important;
                }
                .ps-swiper-arrow-layer .react-multiple-carousel__arrow--right {
                    right: 15px !important;
                    left: auto !important;
                }

                .ps-swiper-arrow-layer .react-multiple-carousel__arrow:disabled {
                    display: none !important;
                }

                .ps-carousel-hover-wrapper .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    opacity: 0 !important;
                    visibility: hidden !important;
                    pointer-events: none !important;
                }
                .ps-carousel-hover-wrapper:hover .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    opacity: 1 !important;
                    visibility: visible !important;
                    pointer-events: auto !important;
                }
                .react-multiple-carousel__arrow:hover {
                    opacity: 1 !important;
                    visibility: visible !important;
                }
                .ps-carousel-hover-wrapper.is-mobile .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    opacity: 1 !important;
                    visibility: visible !important;
                    pointer-events: auto !important;
                }

                .ps-gallery-layout {
                    display: block;
                    width: 100%;
                }

                .ps-gallery-main-image {
                    width: 100%;
                    box-sizing: border-box;
                }

                @media (max-width: 768px) {
                    .ps-gallery-layout {
                        display: grid;
                        grid-template-columns: 76px 1fr;
                        grid-template-areas:
                            'thumbs image'
                            'caption caption';
                        column-gap: 8px;
                        row-gap: 0;
                        align-items: start;
                    }
                    .ps-gallery-main-image {
                        grid-area: image;
                        min-width: 0;
                        width: 100%;
                        max-width: 100%;
                    }
                    .thumbnail-caption-container {
                        grid-area: caption;
                        margin-top: 6px !important;
                    }
                    .product__thumbnailImages-wrapper {
                        grid-area: thumbs;
                        flex-direction: column !important;
                        align-items: center;
                        width: 76px !important;
                        margin-top: 0 !important;
                    }

                    .ps-gallery-layout.single-image {
                        grid-template-columns: 1fr;
                        grid-template-areas:
                            'image'
                            'caption';
                    }
                }

                .thumbnail-caption-container {
                    width: 100%;
                    text-align: center;
                    box-sizing: border-box;
                }

                .product__thumbnailImages-wrapper {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 4px;
                    margin-top: 12px;
                    height: 100px;
                    width: 100%;
                    box-sizing: border-box;
                }

                .ps-thumb-list {
                    height: 101%;
                    flex-direction: row;
                    align-items: center;
                    scroll-margin-top: 7.7rem;
                    display: flex;
                    outline: none !important;
                    box-sizing: inherit;
                    margin: 0px;
                    padding: 0px;
                    flex: 1 1 auto;
                    min-width: 0;
                    overflow: hidden;
                }

                .ps-thumb-list .swiper {
                    width: 100%;
                    height: 100%;
                }

                .ps-thumb-list .swiper-wrapper {
                    align-items: center;
                }

                .ps-thumb-list .swiper-slide {
                    width: 100px !important;
                    height: 100px !important;
                    flex-shrink: 0;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }
                .ps-thumb-list img {
                    width: 100px !important;
                    height: 100px !important;
                    object-fit: contain !important;
                    border: 1px solid transparent;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: border-color 0.2s ease;
                }
                .ps-thumb-list img.active {
                    border-color: var(--color-primary, #1a1a1a);
                }

                .ps-thumb-arrow {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 2.4rem;
                    height: 4.4rem;
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    color: #1a1a1a;
                    flex-shrink: 0;
                    transition: background-color 0.2s ease, opacity 0.2s ease;
                }
                .ps-thumb-arrow:hover:not(:disabled) {
                    background: #ecedf0;
                }
                .ps-thumb-arrow:disabled {
                    opacity: 0.3;
                    cursor: default;
                }
                .ps-thumb-arrow svg {
                    width: 1.6rem;
                    height: 1.6rem;
                    fill: currentColor;
                }

                .ps-thumb-arrow--right svg {
                    transform: rotate(0deg);
                }
                .ps-thumb-arrow--left svg {
                    transform: rotate(180deg);
                }

                @media (max-width: 768px) {
                    .ps-thumb-list {
                        flex-direction: column;
                        height: 100%;
                        width: 100%;
                    }
                    .ps-thumb-list .swiper-slide {
                        width: 64px !important;
                        height: 64px !important;
                    }
                    .ps-thumb-list img {
                        width: 64px !important;
                        height: 64px !important;
                    }
                    .ps-thumb-arrow {
                        width: 100% !important;
                        height: 2rem !important;
                    }
                    .ps-thumb-arrow--left svg {
                        transform: rotate(-90deg);
                    }
                    .ps-thumb-arrow--right svg {
                        transform: rotate(90deg);
                    }
                }

                .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    opacity: 1 !important;
                    visibility: visible !important;
                    pointer-events: auto !important;
                    z-index: 2147483647 !important;
                }

                .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow {
                    background: #f4f4f4 !important;
                    color: #1a1a1a !important;
                }
                .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow::before {
                    color: #1a1a1a !important;
                }
                .product-modal-overlay .ps-swiper-arrow-layer .react-multiple-carousel__arrow svg {
                    fill: #1a1a1a !important;
                }

                .ps-product__thumbnail {
                    width: 100%;
                    box-sizing: border-box;
                }

                .ps-product__thumbnail > figure {
                    width: 100%;
                    flex: 1 1 auto;
                    min-width: 0;
                }

                .ps-product__thumbnail-badges {
                    position: absolute;
                    top: 12px;
                    left: 12px;
                    z-index: 60;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 6px;
                    pointer-events: none;
                }

                @media (max-width: 768px) {
                    .ps-product__thumbnail-badges {
                        left: auto;
                        right: 12px;
                        align-items: flex-end;
                    }
                }
            `}</style>

            <div className="ps-product__thumbnail" data-vertical={!isMobile} style={{ position: 'relative' }}>
                {(showPreorderBadge || showFreeShippingBadge || ageRating) && (
                    <div className="ps-product__thumbnail-badges">
                        {showPreorderBadge && (
                            <div
                                data-testid="product-preorder-badge"
                                className="ps-product__preorder-badge"
                                aria-label="Dieser Artikel kann vorbestellt werden"
                                style={preorderBadgeStyle}
                            >
                                <PreorderIcon />
                                Vorbestellung
                            </div>
                        )}
                        {showFreeShippingBadge && (
                            <div
                                data-testid="product-free-shipping-badge"
                                className="ps-product__free-shipping-badge"
                                style={freeShippingBadgeStyle}
                            >
                                <FreeShippingIcon />
                                Gratis Versand
                            </div>
                        )}
                        {ageRating && (
                            <div
                                data-testid="product-age-badge"
                                data-age-type={ageRating.type}
                                className="ps-product__age-badge"
                                aria-label={`${ageRating.badgeText} Jahren`}
                                style={ageBadgeStyle}
                            >
                                <AgeRatingIcon />
                                {ageRating.badgeText}
                            </div>
                        )}
                    </div>
                )}

                <figure style={{ margin: 0, width: '100%', flex: '1 1 auto', minWidth: 0 }}>
                    <div className={`ps-gallery-layout ${images.length <= 1 ? 'single-image' : ''}`}>
                        <div className="ps-gallery-main-image">
                            <div
                                className={`ps-wrapper carousel--productImages ps-carousel-hover-wrapper ${
                                    isMobile ? 'is-mobile' : ''
                                }`}
                            >
                                {images.length > 1 && (
                                    <div className="ps-swiper-arrow-layer">
                                        <button
                                            aria-label="Go to previous slide"
                                            className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
                                            type="button"
                                            onClick={() => primarySwiperRef.current?.swiper?.slidePrev()}
                                            disabled={activeIndex === 0}
                                        />
                                        <button
                                            aria-label="Go to next slide"
                                            className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
                                            type="button"
                                            onClick={() => primarySwiperRef.current?.swiper?.slideNext()}
                                            disabled={activeIndex === images.length - 1}
                                        />
                                    </div>
                                )}

                                <Swiper
                                    ref={primarySwiperRef}
                                    modules={[Navigation]}
                                    spaceBetween={10}
                                    roundLengths={true}
                                    onSwiper={(swiper) => {
                                        setPrimarySwiper(swiper);
                                        setActiveIndex(swiper.realIndex);
                                    }}
                                    onSlideChange={onPrimarySlideChange}
                                    observer={true}
                                    observeParents={true}
                                    style={{ height: '100%' }}
                                >
                                    {images.map((item, index) => (
                                        <SwiperSlide
                                            key={index}
                                            className="item"
                                            style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div
                                                onClick={() => openModal(index)}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <img
                                                    src={item.url}
                                                    alt={`Produktbild ${index + 1}`}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = placeholderURL;
                                                    }}
                                                    onLoad={refreshGallerySize}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        width: 'auto',
                                                        height: 'auto',
                                                        display: 'block',
                                                        objectFit: 'contain',
                                                        margin: 'auto',
                                                    }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>

                        <div className="thumbnail-caption-container">
                            <p
                                className="thumbnail-caption"
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--color-text)',
                                    display: 'inline-block',
                                    marginTop: '10px',
                                    opacity: 0.55,
                                }}
                            >
                                Abb. kann vom Original abweichen.
                            </p>
                        </div>

                        {images.length > 1 && (
                            <div
                                className="product__thumbnailImages-wrapper"
                                style={{
                                    height: isMobile && galleryHeight ? `${galleryHeight}px` : undefined,
                                }}
                            >
                                <button
                                    type="button"
                                    className="ps-thumb-arrow ps-thumb-arrow--left"
                                    aria-label="Zurück zum vorherigen Produktbild"
                                    onClick={() => horizontalThumbsRef.current?.swiper?.slidePrev()}
                                    disabled={horizontalThumbsNav.isBeginning}
                                >
                                    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                        <path d="m6.71 21.71-1.42-1.42 9.3-9.29-9.3-9.29L6.71.29 17.41 11 6.71 21.71Z" />
                                    </svg>
                                </button>

                                <div className="ps-thumb-list">
                                    <Swiper
                                        key={isMobile ? 'vertical' : 'horizontal'}
                                        ref={horizontalThumbsRef}
                                        className="swiper-carousel--variants"
                                        spaceBetween={5}
                                        slidesPerView="auto"
                                        direction={isMobile ? 'vertical' : 'horizontal'}
                                        freeMode={true}
                                        observer={true}
                                        observeParents={true}
                                        onSwiper={(swiper) =>
                                            setHorizontalThumbsNav({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd })
                                        }
                                        onSlideChange={(swiper) =>
                                            setHorizontalThumbsNav({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd })
                                        }
                                    >
                                        {thumbnailImages.map((item, index) => (
                                            <SwiperSlide className="item" key={index}>
                                                <img
                                                    src={item.url}
                                                    className={`swiper-slide-image ${index === activeIndex ? 'active' : ''}`}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = placeholderURL;
                                                    }}
                                                    onClick={() => handleThumbnailClick(index)}
                                                    onMouseEnter={() => handleThumbnailClick(index)}
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>

                                <button
                                    type="button"
                                    className="ps-thumb-arrow ps-thumb-arrow--right"
                                    aria-label="Weiter zum nächsten Produktbild"
                                    onClick={() => horizontalThumbsRef.current?.swiper?.slideNext()}
                                    disabled={horizontalThumbsNav.isEnd}
                                >
                                    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                        <path d="m6.71 21.71-1.42-1.42 9.3-9.29-9.3-9.29L6.71.29 17.41 11 6.71 21.71Z" />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                </figure>
            </div>

            {showModal && (
                <div
                    className="product-modal-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.9)',
                        zIndex: 2147483647,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        gap: '20px',
                    }}
                    onClick={closeModal}
                >
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            closeModal();
                        }}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            background: 'rgba(255,255,255,0.3)',
                            border: 'none',
                            color: 'white',
                            fontSize: '24px',
                            lineHeight: '1',
                            padding: 0,
                            width: '44px',
                            height: '44px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            zIndex: 2147483647,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontFamily: 'Arial, sans-serif',
                        }}
                    >
                        <span style={{ display: 'inline-block', transform: 'translateY(-1px)' }}>×</span>
                    </button>

                    <div style={{ width: '90vw', maxWidth: '1200px', height: '65vh', position: 'relative' }}>
                        <Swiper
                            ref={modalSwiperRef}
                            spaceBetween={10}
                            thumbs={thumbsSwiper && thumbsSwiper.el ? { swiper: thumbsSwiper } : undefined}
                            initialSlide={modalIndex}
                            modules={[Navigation, Thumbs]}
                            onSwiper={(swiper) => setModalActiveIndex(swiper.realIndex)}
                            onSlideChange={(swiper) => setModalActiveIndex(swiper.realIndex)}
                            style={{ height: '100%' }}
                        >
                            {images.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%',
                                        }}
                                    >
                                        <img
                                            src={item.url}
                                            alt={`Produktbild ${index + 1}`}
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {images.length > 1 && (
                            <div className="ps-swiper-arrow-layer">
                                <button
                                    aria-label="Go to previous slide"
                                    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        modalSwiperRef.current?.swiper?.slidePrev();
                                    }}
                                    disabled={modalActiveIndex === 0}
                                />
                                <button
                                    aria-label="Go to next slide"
                                    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        modalSwiperRef.current?.swiper?.slideNext();
                                    }}
                                    disabled={modalActiveIndex === images.length - 1}
                                />
                            </div>
                        )}
                    </div>

                    {images.length > 1 && (
                        <div
                            style={{
                                width: '90vw',
                                maxWidth: '800px',
                                height: '90px',
                                background: 'rgba(255,255,255,0.1)',
                                borderRadius: '8px',
                                padding: '4px',
                                backdropFilter: 'blur(10px)',
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Swiper
                                ref={modalThumbsRef}
                                spaceBetween={0}
                                slidesPerView={6}
                                centeredSlides={false}
                                watchSlidesProgress={true}
                                modules={[Thumbs]}
                                onSwiper={(swiper) => setThumbsSwiper(swiper)}
                                breakpoints={{
                                    320: { slidesPerView: 3 },
                                    768: { slidesPerView: 4 },
                                    1024: { slidesPerView: 6 },
                                }}
                            >
                                {thumbnailImages.map((item, index) => (
                                    <SwiperSlide key={index} className="modal-thumb-slide">
                                        <div
                                            style={{
                                                width: '70px',
                                                height: '70px',
                                                margin: '4px 10px 0 0',
                                                cursor: 'pointer',
                                                borderRadius: '6px',
                                                overflow: 'hidden',
                                                opacity: 0.8,
                                                transition: 'all 0.3s ease',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleThumbClick(null, index);
                                            }}
                                        >
                                            <img
                                                src={item.url}
                                                alt={`Thumbnail ${index}`}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default ThumbnailDefault;